import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const FileIcon:FC<IProps> = ({size= 15,fill='none'})=>{
    return (
        <BaseIcon size={size} viewBox="0 0 37 49" fill={fill}>
            <path
                d="M21.3733 13.2501L21.3733 0.500122L2.62329 0.500122C1.31079 0.500122 0.373291 1.53137 0.373291 2.75012L0.373291 46.2501C0.373291 47.5626 1.31079 48.5001 2.62329 48.5001L34.1233 48.5001C35.342 48.5001 36.3733 47.5626 36.3733 46.2501L36.3733 15.5001L23.6233 15.5001C22.3108 15.5001 21.3733 14.5626 21.3733 13.2501ZM28.4983 33.1251L19.4983 42.1251C18.842 42.6876 17.8108 42.6876 17.1545 42.1251L8.15454 33.1251C7.21704 32.1876 7.87329 30.5001 9.18579 30.5001L15.3733 30.5001L15.3733 23.0001C15.3733 22.2501 16.0295 21.5001 16.8733 21.5001H19.8733C20.6233 21.5001 21.3733 22.2501 21.3733 23.0001V30.5001H27.467C28.7795 30.5001 29.4358 32.1876 28.4983 33.1251ZM35.717 10.3439L26.5295 1.15637C26.0608 0.781372 25.4983 0.500122 24.9358 0.500122L24.3733 0.500122L24.3733 12.5001L36.3733 12.5001V11.9376C36.3733 11.3751 36.092 10.8126 35.717 10.3439Z"
                fill="#CBCDCF"
            />
        </BaseIcon>
    )
}